import { Trash2, CircleCheck, CircleX } from "lucide-react";

const fmtSlot = (iso) =>
  new Intl.DateTimeFormat("fr-FR", {
    weekday: "short", day: "numeric", month: "short",
    hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris",
  }).format(new Date(iso));

const iconBtn = "rounded-full border border-[#2C2A29]/15 p-2 text-argia-muted transition-colors";

const StatusBadge = ({ b }) => {
  const cancelled = b.status === "annule";
  return (
    <span className={`rounded-full px-3 py-1 text-xs font-semibold ${cancelled ? "bg-red-50 text-argia-red" : "bg-green-50 text-green-700"}`} data-testid={`reservation-status-${b._id}`}>
      {cancelled ? "Annulé" : "Confirmé"}
    </span>
  );
};

const RowActions = ({ b, onStatus, onRemove }) => (
  <div className="flex justify-end gap-2">
    {b.status === "annule" ? (
      <button data-testid={`reservation-confirm-${b._id}`} onClick={() => onStatus(b, "confirme")} title="Re-confirmer" className={`${iconBtn} hover:border-green-600 hover:text-green-700`}>
        <CircleCheck size={16} strokeWidth={1.5} />
      </button>
    ) : (
      <button data-testid={`reservation-cancel-${b._id}`} onClick={() => onStatus(b, "annule")} title="Annuler" className={`${iconBtn} hover:border-argia-red hover:text-argia-red`}>
        <CircleX size={16} strokeWidth={1.5} />
      </button>
    )}
    <button data-testid={`reservation-delete-${b._id}`} onClick={() => onRemove(b)} title="Supprimer" className={`${iconBtn} hover:border-argia-red hover:text-argia-red`}>
      <Trash2 size={16} strokeWidth={1.5} />
    </button>
  </div>
);

const Row = ({ b, onStatus, onRemove }) => (
  <tr className="border-b border-[#2C2A29]/5 last:border-0" data-testid={`reservation-row-${b._id}`}>
    <td className="px-5 py-4 font-semibold text-argia-ink whitespace-nowrap">{fmtSlot(b.slot_start)}</td>
    <td className="px-5 py-4 text-argia-ink">
      <div>{b.name}</div>
      {b.company && <div className="text-xs text-argia-muted">{b.company}</div>}
    </td>
    <td className="px-5 py-4 text-argia-muted">{b.client_type === "professionnel" ? "Pro" : "Particulier"}</td>
    <td className="max-w-[220px] px-5 py-4 text-argia-muted">
      <div>{b.needs.join(", ")}</div>
      {b.offer && <div className="mt-1 inline-block rounded-full bg-argia-stone px-2.5 py-0.5 text-xs font-semibold text-argia-ink" data-testid={`reservation-offer-${b._id}`}>{b.offer}</div>}
    </td>
    <td className="px-5 py-4 text-argia-muted">
      <div>{b.email}</div>
      <div>{b.phone}</div>
    </td>
    <td className="px-5 py-4"><StatusBadge b={b} /></td>
    <td className="px-5 py-4"><RowActions b={b} onStatus={onStatus} onRemove={onRemove} /></td>
  </tr>
);

const HEADERS = ["Créneau", "Client", "Profil", "Besoins", "Contact", "Statut"];

export const ReservationsTable = ({ bookings, onStatus, onRemove }) => (
  <div className="mt-10 overflow-x-auto rounded-2xl border border-[#2C2A29]/10 bg-white" data-testid="reservations-table">
    <table className="w-full min-w-[900px] text-left text-sm">
      <thead>
        <tr className="border-b border-[#2C2A29]/10 text-xs uppercase tracking-[0.15em] text-argia-muted">
          {HEADERS.map((h) => <th key={h} className="px-5 py-4">{h}</th>)}
          <th className="px-5 py-4 text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {bookings.map((b) => <Row key={b._id} b={b} onStatus={onStatus} onRemove={onRemove} />)}
      </tbody>
    </table>
  </div>
);
